import { useState } from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";

interface ExpiredLinkMessageProps {
  onEmailSent: () => void;
}

const ExpiredLinkMessage = ({ onEmailSent }: ExpiredLinkMessageProps) => {
  const [email, setEmail] = useState("");

  const handleResendResetLink = async () => {
    if (!email) {
      toast.error('Please enter your email address');
      return;
    }

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email);
      if (error) throw error;
      toast.success('Password reset link has been sent to your email');
      onEmailSent();
    } catch (error) {
      console.error('Error sending reset link:', error);
      toast.error('Failed to send reset link. Please try again.');
    }
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900">Password Reset Link Expired</h2>
        <p className="mt-2 text-sm text-gray-600">
          The password reset link has expired. Please enter your email to receive a new link.
        </p>
      </div>
      <div className="space-y-4">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <Button
          onClick={handleResendResetLink}
          className="w-full"
        >
          Send New Reset Link
        </Button>
      </div>
    </div>
  );
};

export default ExpiredLinkMessage;